export var DateTagType;
(function (DateTagType) {
    DateTagType[DateTagType["holiday"] = 1] = "holiday";
    // 假期
    DateTagType[DateTagType["working"] = 2] = "working";
    // 工作日
    DateTagType[DateTagType["unset"] = 0] = "unset";
})(DateTagType || (DateTagType = {}));
export var TooltipType;
(function (TooltipType) {
    TooltipType[TooltipType["none"] = 0] = "none";
    // 无
    TooltipType[TooltipType["invalid"] = 1] = "invalid";
    // 没有选择结束日期
    TooltipType[TooltipType["dawn"] = 2] = "dawn";
    // 凌晨入住提示
    TooltipType[TooltipType["dawnNoon"] = 3] = "dawnNoon"; // 选择当天中午的凌晨入住提示
})(TooltipType || (TooltipType = {}));
export var DateShortcutType;
(function (DateShortcutType) {
    DateShortcutType[DateShortcutType["todayBeforeDawn"] = -1] = "todayBeforeDawn";
    DateShortcutType[DateShortcutType["unset"] = 0] = "unset";
    DateShortcutType[DateShortcutType["today"] = 1] = "today";
    DateShortcutType[DateShortcutType["tommorrow"] = 2] = "tommorrow";
})(DateShortcutType || (DateShortcutType = {}));
